import type {
  Modification,
  NavigationEditSchemaType,
} from '@carboncopyco/types';
import React from 'react';

export interface NavigationRulesManagerContextProps {
  rules: Modification<NavigationEditSchemaType.blockInteractions>[];
  createRule?: (
    rule: Omit<
      Modification<NavigationEditSchemaType.blockInteractions>,
      'ruleId'
    >
  ) => Promise<unknown>;
  editRule?: (
    rule: Modification<NavigationEditSchemaType.blockInteractions>
  ) => Promise<unknown>;
  deleteRule?: (
    rule: Modification<NavigationEditSchemaType.blockInteractions>
  ) => Promise<unknown>;
  reorderRules?: (
    moved: Modification<NavigationEditSchemaType.blockInteractions>,
    after: Modification<NavigationEditSchemaType.blockInteractions>
  ) => Promise<unknown>;
}

export const NavigationRulesContext =
  React.createContext<NavigationRulesManagerContextProps>(undefined);
